const initialState = {
  // cabinType: [],
  // soloType: [],
  data: {}
  // weeks: [],
  // week: {},
};

const cabins = (state = initialState, action) => {
  switch (action.type) {
  // case 'CHANGE_CABIN_TYPE':
  //   return {
  //     ...state,
  //     cabinType: action.cabinType,
  //   };
  //
  // case 'CHANGE_SOLO_TYPE':
  //   return {
  //     ...state,
  //     soloType: action.soloType,
  //   };
  //
  // case 'CLEAR_CABIN_AND_SOLO_TYPE':
  //   return {
  //     ...state,
  //     cabinType: [],
  //     soloType: [],
  //   };
  //
  // case 'SELECT_CABIN_RATING':
  //   return {
  //     ...state,
  //     cabinRating: action.cabinRating,
  //     weeks: action.cabinWeeks === undefined ? state.weeks : action.cabinWeeks,
  //   };
  //
  // case 'UPDATE_CABIN_WEEKS':
  //   return {
  //     ...state,
  //     weeks: action.cabinWeeks === undefined ? state.weeks : action.cabinWeeks,
  //   };
  //
  // case 'SELECT_WEEK':
  //   return {
  //     ...state,
  //     week: action.week,
  //   };

  case 'SET_CABIN_WEEKS':
    return {
      ...state,
      data: action.weeks
    };
  default:
    return state;
  }
};

export default cabins;
